// lib
import React, { PureComponent } from 'react';
import { CUSTOMER_SERVICE, PRODUCT_NAME } from "../../constants/config";

// style
import './Footer.less';

export default class Footer extends PureComponent {
  render() {
    return (
      <div className="ap-footer-wrapper">
        <div className="ap-footer-connection">
          {PRODUCT_NAME}客服热线电话：{CUSTOMER_SERVICE.phone} （周一至周五 9:00-18:00）     服务邮箱：{CUSTOMER_SERVICE.email}
        </div>
        <div className="ap-footer-copyright">
          ©2019 中娱（天津）商业保理有限公司 版权所有
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Layout/Footer.jsx